import { createAction } from '@ngrx/store';

const loadUser = createAction('[Has Permission Guard] Load user');
export const HasPermissionGuardActions = {
  loadUser,
};
